import { Module } from 'vuex';
import { MainType, RegistrationProcessState } from '@/types/state/registrationProcess';
import { RootState } from '@/types/state/root';
import api from '@/api';
import { DataResponse } from '@/types/api/registerProcess';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let infoTicketRequest: any = null;

export default {
  namespaced: true,
  state(): RegistrationProcessState {
    return {
      supplierCategories: [],
      contractorWorkTypes: [],
      agreements: [],
      regions: [],
      taxationForms: [],
      selectedRoles: [],
      flags: {
        isGenContractor: false,
        isContractor: false,
        isSupplier: false,
        isCustomer: false,
      },
      mainType: '',
      step: 1,
      form: {
        captcha: {
          code: '',
          sid: '',
        },
        organization: {
          isResident: null,
          name: '',
          subject: '',
          settlement: '',
          legalAddress: '',
          inn: '',
          kpp: '',
          ogrn: '',
        },
        user: {
          fullName: '',
          phone: '',
          login: '',
          password: '',
          repeatPassword: '',
          personalDataAgree: true,
          marketingAgree: true,
        },
        roles: [],
        supplier: {
          categoryIds: [],
        },
        contractor: {
          workTypeIds: [],
        },
        gencontractor: {
          headFullName: '',
          headJobTitle: '',
          okvedCodes: '',
          taxationFormId: '0',
          sroCertificate: '',
          previousCustomer: '',
          buildingCareerStart: '',
          workList: '',
          bankName: '',
          bankBik: '',
          bankCorrespondentAccount: '',
          bankPaymentAccount: '',
        },
      },
    };
  },
  getters: {
    isHidden: (state) => !state.flags.isGenContractor && !state.flags.isContractor && !state.flags.isSupplier && !state.flags.isCustomer,
  },
  mutations: {
    changeData(state, data) {
      Object.keys(data).forEach((key: string) => {
        state.form[key] = data[key];
      });
    },

    setData1Step(state, data) {
      const {
        mainType, organization, supplier, contractor, gencontractor,
      } = data;

      state.mainType = mainType ?? '';
      state.form.organization = {
        ...state.form.organization,
        ...organization,
        isResident: organization.isResident ?? null,
        name: organization.name ?? '',
        subject: organization.subject ?? '',
        settlement: organization.settlement ?? '',
        legalAddress: organization.legalAddress ?? '',
        inn: organization.inn ?? '',
        kpp: organization.kpp ?? '',
        ogrn: organization.ogrn ?? '',
      };

      state.form.roles = state.selectedRoles;

      if (state.flags.isSupplier) {
        state.form.supplier = {
          ...state.form.supplier,
          categoryIds: supplier.categoryIds ?? [],
        };
      } else {
        state.form.supplier = {};
      }

      if (state.flags.isContractor) {
        state.form.contractor = {
          ...state.form.contractor,
          workTypeIds: contractor.workTypeIds ?? [],
        };
      } else if (!state.flags.isGenContractor) {
        state.form.contractor = {};
      }

      if (state.flags.isGenContractor) {
        state.form.contractor = {
          ...state.form.contractor,
          workTypeIds: contractor.workTypeIds ?? [],
        };
        state.form.gencontractor = {
          ...state.form.gencontractor,
          headFullName: gencontractor.headFullName ?? '',
          headJobTitle: gencontractor.headJobTitle ?? '',
          okvedCodes: gencontractor.okvedCodes ?? '',
          taxationFormId: gencontractor.taxationFormId ?? '0',
          sroCertificate: gencontractor.sroCertificate ?? '',
          previousCustomer: gencontractor.previousCustomer ?? '',
          buildingCareerStart: gencontractor.buildingCareerStart ?? '',
          workList: gencontractor.workList ?? '',
          bankName: gencontractor.bankName ?? '',
          bankBik: gencontractor.bankBik ?? '',
          bankCorrespondentAccount: gencontractor.bankCorrespondentAccount ?? '',
          bankPaymentAccount: gencontractor.bankPaymentAccount ?? '',
        };

        if (!state.flags.isContractor) {
          state.form.roles.push('contractor');
        }
      } else {
        state.form.gencontractor = {};
      }
    },

    setData2Step(state, data) {
      const { user, captcha } = data;

      state.form.user = {
        ...state.form.user,
        fullName: user.fullName ?? '',
        phone: user.phone ?? '',
        login: user.login ?? '',
        password: user.password ?? '',
        repeatPassword: user.repeatPassword ?? '',
        personalDataAgree: user.personalDataAgree ?? false,
        marketingAgree: user.marketingAgree ?? false,
      };

      state.form.captcha = {
        ...state.form.captcha,
        code: captcha.code ?? '',
        sid: captcha.sid ?? '',
      };
    },

    changeType(state, type: MainType) {
      state.mainType = type;
      const index = state.selectedRoles.indexOf(type);
      if (index === -1) {
        state.selectedRoles.push(type);
      } else {
        state.selectedRoles.splice(index, 1);
      }
      state.flags.isSupplier = state.selectedRoles.indexOf('supplier') !== -1;
      state.flags.isContractor = state.selectedRoles.indexOf('contractor') !== -1;
      state.flags.isGenContractor = state.selectedRoles.indexOf('gencontractor') !== -1;
      state.flags.isCustomer = state.selectedRoles.indexOf('customer') !== -1;
    },

    setStep(state, step: number) {
      state.step = step;
    },

    setLists(state, { result }: DataResponse) {
      state.supplierCategories = result.supplierCategories;
      state.contractorWorkTypes = result.contractorWorkTypes;
      state.regions = result.regions;
      state.taxationForms = result.taxationForms;
      state.agreements = result.agreements;
    },
  },

  actions: {

    registration({ state }) {
      return api.register.registerProcess(state.form)
        .catch((e) => Promise.reject(e.response ? e.response.data : e));
    },

    async info({ commit }) {
      try {
        if (infoTicketRequest) {
          return;
        }
        infoTicketRequest = api.register.data();
        const { data }: { data: DataResponse } = await infoTicketRequest;
        commit('setLists', data);
      } catch (e) {
        console.log(e);
      }
      infoTicketRequest = null;
    },
  },

} as Module<RegistrationProcessState, RootState>;
